(ns common.schema.entities.real-estate.core
  (:require [common.roles :as roles]
            [common.schema.entities.real-estate :as real-estate]))

;; Verbatim copy of common.schema.entity-types's shared crm-delete-check-fn,
;; which real-estate's existing entry references directly - required here,
;; not there, to avoid a circular namespace dependency (entity_types.cljc
;; requires this registry). Keep in sync if the original ever changes.
(defn- disable-permissions-check-fn
  [{:keys [tr role]}]
  (when-not (roles/user? role)
    (tr :not-allowed)))

(def entity-type-definition
  {:entity-type                  :entity.type/real-estate
   :schema                       real-estate/schema
   :name                         {:en "Real estate"}
   :plural                       {:en "Real estate"}
   :icon                         :fa-house
   :create-icon                  :fa-house
   :read-permissions-check-fn    (fn [{:keys []}] true)
   :disable-permissions-check-fn disable-permissions-check-fn

   ;; Explicitly false: real-estate's dedicated OpenSearch index already
   ;; exists and is populated via the legacy common.opensearch.entity-indices
   ;; mechanism, not the newer :entity/search-index?-driven
   ;; backend.search.dedicated.indexes/init! path - this key would otherwise
   ;; default to true just because :search is present below.
   :search-index?                false

   :search                       {:result/title-attr    :asset/name
                                  :list/default-columns [:asset/name
                                                         :asset/description
                                                         :asset/city
                                                         :real-estate/tag-tags
                                                         :real-estate/current-yield
                                                         :real-estate/occupancy-rate]
                                  :views                {:grid {:po-default-field-paths [[:asset/name]
                                                                                         [:asset/description]
                                                                                         [:asset/city]
                                                                                         [:real-estate/tag-tags]
                                                                                         [:real-estate/current-yield]
                                                                                         [:real-estate/occupancy-rate]]
                                                                :mandatory-field-paths  [[:asset/name]]}}}})
